import { Theme, makeStyles } from "@material-ui/core";

interface StylesProps{
    primary?: string;
    secondary?: string;
}

export const useStyles = makeStyles<Theme, StylesProps>((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gridGap: theme.spacing(2),
        paddingBottom: theme.spacing(3)
    },
    icon: {
        fill: theme.palette.warning.main,
        width: 92,
        height: 92
    },
    title: {
        color: '#6B6B6B',
        fontWeight: 600,
        fontSize: '1.5rem'
    },
    text: {
        color: theme.palette.text.secondary,
        fontSize: '0.9rem'
    },
    buttonContainer: {
        display: 'flex',
        gridGap: theme.spacing(2),
        alignItems: 'center'
    },
    buttonPrimary:{
        background: ({primary}) => primary ? primary : theme.palette.success.dark,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            background: ({primary}) => primary ? primary : theme.palette.success.dark
        }
    },
    buttonSecondary: {
        background: ({secondary}) => secondary ? secondary : theme.palette.error.dark,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            background: ({secondary}) => secondary ? secondary : theme.palette.error.dark,
        }
    }
}));